// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .dashboard-container{
    display: flex;
    width: 100%;
    
  .user-dashboard-container {
    max-width: 800px;
    margin: 10px 0px 0px 0px;
  }
  .users-container{
    margin: 20px 50px;
    width: 100%;
  }
  
  h1,
  h2 {
    text-align: center;
    color: #333;
  }
  
  /* Form styles */
  .user-form {
    margin-bottom: 20px;
    display: flex;
    width: 100%; /* or any fixed width, like 300px */
  max-width: 100%;
  }
  
  .user-form input {
    /* flex: 1 1 calc(33.333% - 10px);
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
 */

    padding: 0px 0px 0px 12px;
        border: 1px solid #ccc;
        border-radius: 5px;
        
        height: 2.3rem;
        width: 25%;
    margin-right: 1%;
  }

  .email-input{
    width: 50% !important;
  }
  
  .user-form input:focus {
    outline: none;
    border-color: #007bff;
  }
  
  .user-form .btn-submit {
    background-color: #007bff;
        color: #fff;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        
        width: 14%;
        height: 2.3rem;
  }
  
  .user-form .btn-submit:hover {
    background-color: #0056b3;
  }



  .user-form .disabled-btn {
    background-color: #007bff;
        color: #fff;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        
        width: 14%;
        height: 2.3rem;
        opacity: 0.5;
        cursor: not-allowed;
  }
  
  .user-form .disabled-btn:hover {
    background-color: #0056b3;
    opacity: 0.5;
  }
  
  /* User list styles */
  .user-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  
  .user-list-item {
    display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 15px 8px 15px;
            margin-bottom: 10px;
            background-color: #f9f9f9;
            border: 1px solid #ddd;
            border-radius: 5px;
  }
  
  .user-info {
    
    text-align: left;
    width: 30%;
  }
  
  .user-actions button {
    margin-left: 10px;
    padding: 5px 10px;  
    
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-edit {
    background-color: #ffc107;
    color: #fff;
  }
  
  .btn-edit:hover {
    background-color: #e0a800;
  }
  
  .btn-delete {
    background-color: #dc3545;
    color: #fff;
  }
  
  .btn-delete:hover {
    background-color: #bd2130;
  }
  
  /* Responsive styles */
  @media (max-width: 600px) {
    .user-form input {
      flex: 1 1 100%;
    }
  
    .user-actions button {
      margin-left: 5px;
      padding: 8px;
    }
  
    .user-list-item {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .user-actions {
      margin-top: 10px;
    }
  }



  /* Dropdown Container */
.dropdown {
  display: inline-block;
  margin-right: 1%;
  padding: 0px 0px 0px 10px;
  cursor: pointer;
  text-align: left;
  position: relative;
  flex-basis: calc(33.333% - 10px);
  border: 1px solid #ccc;
  border-radius: 5px;
  background: none;
  height: 2.3rem;
  }
  
  .dropdown-option:hover {
    background-color: #f3f4f6;
  }
  
  /* Active Dropdown */
  .dropdown:hover .dropdown-options {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/dashboard.css"],"names":[],"mappings":"EAAE;IACE,aAAa;IACb,WAAW;;EAEb;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;;IAEE,kBAAkB;IAClB,WAAW;EACb;;EAEA,gBAAgB;EAChB;IACE,mBAAmB;IACnB,aAAa;IACb,WAAW,EAAE,mCAAmC;EAClD,eAAe;EACf;;EAEA;IACE;;;;EAIF;;IAEE,yBAAyB;QACrB,sBAAsB;QACtB,kBAAkB;;QAElB,cAAc;QACd,UAAU;IACd,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;QACrB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,eAAe;;QAEf,UAAU;QACV,cAAc;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;;;EAIA;IACE,yBAAyB;QACrB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,eAAe;;QAEf,UAAU;QACV,cAAc;QACd,YAAY;QACZ,mBAAmB;EACzB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA,qBAAqB;EACrB;IACE,qBAAqB;IACrB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;YACL,8BAA8B;YAC9B,mBAAmB;YACnB,0BAA0B;YAC1B,mBAAmB;YACnB,yBAAyB;YACzB,sBAAsB;YACtB,kBAAkB;EAC5B;;EAEA;;IAEE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;;IAEjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE;MACE,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,YAAY;IACd;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;IAClB;EACF;;;;EAIA,uBAAuB;AACzB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,oBAAoB;EACpB;IACE,cAAc;EAChB;AACF","sourcesContent":["  .dashboard-container{\n    display: flex;\n    width: 100%;\n    \n  .user-dashboard-container {\n    max-width: 800px;\n    margin: 10px 0px 0px 0px;\n  }\n  .users-container{\n    margin: 20px 50px;\n    width: 100%;\n  }\n  \n  h1,\n  h2 {\n    text-align: center;\n    color: #333;\n  }\n  \n  /* Form styles */\n  .user-form {\n    margin-bottom: 20px;\n    display: flex;\n    width: 100%; /* or any fixed width, like 300px */\n  max-width: 100%;\n  }\n  \n  .user-form input {\n    /* flex: 1 1 calc(33.333% - 10px);\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n */\n\n    padding: 0px 0px 0px 12px;\n        border: 1px solid #ccc;\n        border-radius: 5px;\n        \n        height: 2.3rem;\n        width: 25%;\n    margin-right: 1%;\n  }\n\n  .email-input{\n    width: 50% !important;\n  }\n  \n  .user-form input:focus {\n    outline: none;\n    border-color: #007bff;\n  }\n  \n  .user-form .btn-submit {\n    background-color: #007bff;\n        color: #fff;\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        \n        width: 14%;\n        height: 2.3rem;\n  }\n  \n  .user-form .btn-submit:hover {\n    background-color: #0056b3;\n  }\n\n\n\n  .user-form .disabled-btn {\n    background-color: #007bff;\n        color: #fff;\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        \n        width: 14%;\n        height: 2.3rem;\n        opacity: 0.5;\n        cursor: not-allowed;\n  }\n  \n  .user-form .disabled-btn:hover {\n    background-color: #0056b3;\n    opacity: 0.5;\n  }\n  \n  /* User list styles */\n  .user-list {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .user-list-item {\n    display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 8px 15px 8px 15px;\n            margin-bottom: 10px;\n            background-color: #f9f9f9;\n            border: 1px solid #ddd;\n            border-radius: 5px;\n  }\n  \n  .user-info {\n    \n    text-align: left;\n    width: 30%;\n  }\n  \n  .user-actions button {\n    margin-left: 10px;\n    padding: 5px 10px;  \n    \n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .btn-edit {\n    background-color: #ffc107;\n    color: #fff;\n  }\n  \n  .btn-edit:hover {\n    background-color: #e0a800;\n  }\n  \n  .btn-delete {\n    background-color: #dc3545;\n    color: #fff;\n  }\n  \n  .btn-delete:hover {\n    background-color: #bd2130;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 600px) {\n    .user-form input {\n      flex: 1 1 100%;\n    }\n  \n    .user-actions button {\n      margin-left: 5px;\n      padding: 8px;\n    }\n  \n    .user-list-item {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  \n    .user-actions {\n      margin-top: 10px;\n    }\n  }\n\n\n\n  /* Dropdown Container */\n.dropdown {\n  display: inline-block;\n  margin-right: 1%;\n  padding: 0px 0px 0px 10px;\n  cursor: pointer;\n  text-align: left;\n  position: relative;\n  flex-basis: calc(33.333% - 10px);\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background: none;\n  height: 2.3rem;\n  }\n  \n  .dropdown-option:hover {\n    background-color: #f3f4f6;\n  }\n  \n  /* Active Dropdown */\n  .dropdown:hover .dropdown-options {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
